// extracted by mini-css-extract-plugin
export default {"search-form":"X_Qd flex-grow-1 form-group mb-0"};